import { Button, ButtonProps } from "@mui/material";
import { DebounceButton } from "../external/ensolvers-core-frontend-mui/components/Common/DebounceButton";
import { AppSpinner } from "./AppSpinner";

export const ButtonComponent = (
  props: ButtonProps & {
    icon?: JSX.Element;
    text: string;
    onClick: () => void;
    debounce?: boolean;
    inverseIcon?: boolean;
    isLoading?: boolean;
    clearStyles?: boolean;
  }
) => {
  const debounceBtnProps = { ...props, icon: undefined, isLoading: false };
  const btnProps = { ...debounceBtnProps, debounce: undefined, text: undefined };

  const getIcon = () => {
    return props.isLoading ? <AppSpinner size={20} /> : props.icon;
  };

  return props.debounce ? (
    <DebounceButton
      style={props.clearStyles ? { padding: "0", minWidth: "0" } : {}}
      startIcon={!props.inverseIcon && getIcon()}
      endIcon={props.inverseIcon && getIcon()}
      {...debounceBtnProps}
    />
  ) : (
    <Button
      style={props.clearStyles ? { padding: "0", minWidth: "0" } : {}}
      startIcon={!props.inverseIcon && getIcon()}
      endIcon={props.inverseIcon && getIcon()}
      variant="text"
      color="inherit"
      {...btnProps}
    >
      {props.text}
    </Button>
  );
};
